<div class="table-responsive">
  <table class="table table-striped" [ngClass]="{ 'table-hover': hoverStyle }">
    @if (config.rows.length > 0) {
      <ng-content select="[header]"></ng-content>
    }
    <ng-content select="[body]"></ng-content>
  </table>
  @if (config.rows.length == 0) {
    <div class="w-100 text-center mt-2">
      <h4>{{ 's1.table.noElements' | translate }}</h4>
    </div>
  }
  <div class="w-100 text-center mt-4">
    <s1-pagination #pagination [table]="config" [onlinePagination]="onlinePagination" (pageChanged)="paginationUpdated()" ></s1-pagination>
  </div>
</div>